import { InvoiceBatchProcess } from "./InvoiceBatchProcess";

export default InvoiceBatchProcess;
